<template>
    <div>
        <div :style="boutonStyle" v-show="minus">
            <v-badge
                color="red"
                class="align-self-center"
                :content="unreadChatCount"
                :model-value="unreadChatCount > 0"
            >
                <template #badge>
                    <span v-if="unreadChatCount !== 0">{{ unreadChatCount }}</span>
                </template>
                <v-btn
                    @click="reduce()"
                    icon="$fa-comments"
                    :size="$vuetify.display.mobile ? 'small' : undefined"
                    elevation="1"
                />
            </v-badge>
        </div>

        <v-dialog
            v-model="showDialog"
            fullscreen
            hide-overlay
            v-if="$vuetify.display.mobile"
            transition="dialog-bottom-transition"
        >
            <v-card class="mx-auto" width="350px" rounded="0">
                <v-toolbar class="elevation-0" color="primary" rounded="0" :flat="true">
                    <!-- <v-app-bar-nav-icon></v-app-bar-nav-icon> -->
                    <v-toolbar-title>{{ title }}</v-toolbar-title>
                    <v-spacer />

                    <v-menu location="start">
                        <template v-slot:activator="{ props: menu }">
                            <v-icon icon="$tune" v-bind="menu" v-tooltip.top="'Filtres'" />
                        </template>
                        <v-list density="compact">
                            <v-list-item @click.stop="filter = 'all'">
                                <template #append>
                                    <v-icon size="small" v-if="filter === 'all'">$check</v-icon>
                                </template>

                                <v-list-item-title
                                    >Tous les messages</v-list-item-title
                                ></v-list-item
                            >
                            <v-list-item @click.stop="filter = 'waitingResponse'">
                                <template #append>
                                    <v-icon size="small" v-if="filter === 'waitingResponse'"
                                        >$check</v-icon
                                    >
                                </template>

                                <v-list-item-title
                                    >Message en attente de réponse</v-list-item-title
                                ></v-list-item
                            >
                            <v-list-item @click.stop="filter = 'messageSent'">
                                <template #append>
                                    <v-icon size="small" v-if="filter === 'messageSent'"
                                        >$check</v-icon
                                    >
                                </template>

                                <v-list-item-title>Message envoyé</v-list-item-title></v-list-item
                            >
                            <v-list-item @click.stop="filter = 'messageClosed'">
                                <template #append>
                                    <v-icon size="small" v-if="filter === 'messageClosed'"
                                        >$check</v-icon
                                    >
                                </template>
                                <v-list-item-title>Message fermé</v-list-item-title></v-list-item
                            >
                        </v-list>
                    </v-menu>
                    <!-- <v-btn icon @click="reduce()" style="margin: 0;">
                    <v-icon style="color: #FFF">{{ showDialog ? "$fa-chevron-down" : "$fa-chevron-up" }}</v-icon>
                </v-btn> -->

                    <v-btn @click="reduce()" style="margin: 0">
                        <v-icon style="color: #fff">{{
                            showDialog ? "$fa-chevron-down" : "$fa-chevron-up"
                        }}</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-layout style="overflow-y: auto">
                    <v-list
                        v-if="filteredChats && filteredChats.length"
                        width="100%"
                        density="compact"
                        lines="three"
                    >
                        <!-- <template
                        > -->
                        <!-- <v-subheader
                            v-if="item.header"
                            :key="item.header"
                            v-text="item.header"
                            ></v-subheader> -->
                        <!-- <v-divider
                            v-else-if="item.divider"
                            :key="index"
                            :inset="item.inset"
                            ></v-divider> -->
                        <v-list-item
                            :key="item.id"
                            :data-item-id="item.id"
                            @click="openChat(item)"
                            class="oss-list-item mx-2 mb-2"
                            v-for="item in filteredChats"
                            density="compact"
                            @mouseenter="hoveredItem = item.id"
                            @mouseleave="hoveredItem = null"
                        >
                            <template #prepend>
                                <v-avatar
                                    :color="
                                        !currentUser ||
                                        !item.lastMessage?.sender?.id ||
                                        item.lastMessage.sender.id !== currentUser.id
                                            ? 'primary'
                                            : 'secondary'
                                    "
                                    size="small"
                                >
                                    {{ getUserBigram(item.lastMessage.sender) }}
                                </v-avatar>
                            </template>

                            <template v-slot:append>
                                <span class="message-date">{{
                                    getDate(item.lastMessage.createdAt)
                                }}</span>

                                <div v-if="isInAccountingFirm" class="menu-container">
                                    <!-- Contextual Menu -->
                                    <v-btn
                                        icon
                                        size="small"
                                        class="menu-button"
                                        @click.stop="toggleMenu(item.id)"
                                        :class="{ 'menu-open': menuOpen === item.id }"
                                    >
                                        <v-icon size="small" v-if="menuOpen === item.id"
                                            >$fa-chevron-right</v-icon
                                        >
                                        <v-icon size="small" v-else>$fa-ellipsis-v</v-icon>
                                    </v-btn>

                                    <!-- Menu actions -->
                                    <div
                                        v-if="hoveredItem === item.id || menuOpen === item.id"
                                        class="menu-actions"
                                        :class="{ 'menu-actions--open': menuOpen === item.id }"
                                        :style="{ height: getItemHeight(item.id) + 'px' }"
                                    >
                                        <div
                                            class="menu-item"
                                            @click.stop="markChatAsProcessed(item.id)"
                                        >
                                            <v-icon size="x-small" class="mr-1">$fa-check</v-icon>
                                            <span>Traité</span>
                                        </div>
                                        <div class="menu-item" @click.stop="relaunchChat(item)">
                                            <v-icon size="x-small" class="mr-1">$fa-retweet</v-icon>
                                            <span>Relancer</span>
                                        </div>
                                    </div>
                                </div>
                            </template>

                            <v-list-item-title
                                v-text="getUserDisplayName(item.lastMessage.sender)"
                            />
                            <v-list-item-subtitle v-text="item.lastMessage.text" />
                            <v-list-item-title
                                ><v-icon dense class="mr-2">{{ getTypeIcon(item) }}</v-icon
                                >{{ getType(item) }}
                            </v-list-item-title>
                            <v-icon
                                icon="$check"
                                v-tooltip.top="'Conversation traitée'"
                                size="small"
                                class="oss-list-item__icon"
                                v-if="item.processed"
                            />
                            <!-- <v-list-item-subtitle v-text="item.lastMessage.sender.firstname +
                                    ' ' +
                                    item.lastMessage.sender.lastname +
                                    ' ' +
                                    item.lastMessage.text
                                    " /> -->
                        </v-list-item>
                        <!-- </template> -->
                    </v-list>
                    <v-list v-else>
                        <v-list-item class="oss-list-item pl-2">
                            <v-list-item-title> Pas de message </v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-layout>
            </v-card>
        </v-dialog>
        <div
            v-else
            style="position: fixed; right: -70px; width: 30%; bottom: 1vmin; z-index: 10"
            v-show="!minus"
        >
            <v-card class="mx-auto" elevation="1" width="350px" rounded="lg">
                <v-toolbar class="elevation-0" color="primary" rounded="0" :flat="true">
                    <v-toolbar-title>{{ title }}</v-toolbar-title>
                    <v-spacer />

                    <v-menu location="start">
                        <template v-slot:activator="{ props: menu }">
                            <v-btn-icon icon="$tune" v-bind="menu" v-tooltip.top="'Filtres'" />
                        </template>
                        <v-list dense>
                            <v-list-item @click="filter = 'all'" dense>
                                <template #append>
                                    <v-icon size="small" v-if="filter === 'all'">$check</v-icon>
                                </template>

                                <v-list-item-title
                                    >Tous les messages</v-list-item-title
                                ></v-list-item
                            >
                            <v-list-item @click="filter = 'waitingResponse'" dense>
                                <template #append>
                                    <v-icon size="small" v-if="filter === 'waitingResponse'"
                                        >$check</v-icon
                                    >
                                </template>

                                <v-list-item-title
                                    >Message en attente de réponse</v-list-item-title
                                ></v-list-item
                            >
                            <v-list-item @click="filter = 'messageSent'" dense>
                                <template #append>
                                    <v-icon size="small" v-if="filter === 'messageSent'"
                                        >$check</v-icon
                                    >
                                </template>

                                <v-list-item-title>Message envoyé</v-list-item-title></v-list-item
                            >
                            <v-list-item @click="filter = 'messageClosed'" dense>
                                <template #append>
                                    <v-icon size="small" v-if="filter === 'messageClosed'"
                                        >$check</v-icon
                                    >
                                </template>

                                <v-list-item-title>Message fermé</v-list-item-title></v-list-item
                            >
                        </v-list>
                    </v-menu>
                    <v-btn @click="reduce()" style="margin: 0">
                        <v-icon style="color: #fff">{{
                            showDialog ? "$fa-chevron-down" : "$fa-chevron-up"
                        }}</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-layout style="height: 300px; overflow-y: auto">
                    <v-list
                        v-if="filteredChats && filteredChats.length"
                        width="100%"
                        density="compact"
                        lines="three"
                    >
                        <!-- <template v-for="(item) in chats"
                    > -->
                        <!-- <v-subheader
                        v-if="item.header"
                        :key="item.header"
                        v-text="item.header"
                        ></v-subheader> -->
                        <!-- <v-divider
                        v-else-if="item.divider"
                        :key="index"
                        :inset="item.inset"
                        ></v-divider> -->

                        <v-list-item
                            :key="item.id"
                            :data-item-id="item.id"
                            @click="openChat(item)"
                            class="oss-list-item mx-2 mb-2"
                            v-for="item in filteredChats"
                            :id="'chat-' + item.id"
                            density="compact"
                            @mouseenter="hoveredItem = item.id"
                            @mouseleave="hoveredItem = null"
                        >
                            <template #prepend>
                                <v-avatar
                                    :color="
                                        item.lastMessage?.sender?.id !== currentUser?.id
                                            ? 'primary'
                                            : 'secondary'
                                    "
                                    size="small"
                                >
                                    {{ getUserBigram(item.lastMessage.sender) }}
                                </v-avatar>
                            </template>

                            <template v-slot:append>
                                <span class="message-date">{{
                                    getDate(item.lastMessage.createdAt)
                                }}</span>

                                <div v-if="isInAccountingFirm" class="menu-container">
                                    <!-- Contextual Menu -->
                                    <v-btn
                                        icon
                                        size="small"
                                        class="menu-button"
                                        v-if="hoveredItem === item.id || menuOpen === item.id"
                                        @click.stop="toggleMenu(item.id)"
                                        :class="{ 'menu-open': menuOpen === item.id }"
                                    >
                                        <v-icon size="small" v-if="menuOpen === item.id"
                                            >$fa-chevron-right</v-icon
                                        >
                                        <v-icon size="small" v-else>$fa-ellipsis-v</v-icon>
                                    </v-btn>

                                    <!-- Menu actions -->
                                    <div
                                        v-if="hoveredItem === item.id || menuOpen === item.id"
                                        class="menu-actions"
                                        :class="{ 'menu-actions--open': menuOpen === item.id }"
                                        :style="{ height: getItemHeight(item.id) + 'px' }"
                                    >
                                        <div
                                            class="menu-item"
                                            @click.stop="markChatAsProcessed(item.id)"
                                        >
                                            <v-icon size="x-small" class="mr-1">$fa-check</v-icon>
                                            <span>Traité</span>
                                        </div>
                                        <div class="menu-item" @click.stop="relaunchChat(item)">
                                            <v-icon size="x-small" class="mr-1">$fa-retweet</v-icon>
                                            <span>Relancer</span>
                                        </div>
                                    </div>
                                </div>
                            </template>

                            <v-list-item-title
                                v-text="getUserDisplayName(item.lastMessage.sender)"
                            />
                            <v-list-item-subtitle v-text="item.lastMessage.text" />
                            <v-list-item-subtitle>
                                <v-icon class="mr-2" size="x-small">{{ getTypeIcon(item) }}</v-icon>
                                {{ getType(item) }}
                            </v-list-item-subtitle>
                            <v-icon
                                icon="$check"
                                v-tooltip.top="'Conversation traitée'"
                                size="small"
                                class="oss-list-item__icon"
                                v-if="item.processed"
                            />
                        </v-list-item>
                    </v-list>
                    <v-list v-else>
                        <v-list-item class="oss-list-item pl-2">
                            <v-list-item-title> Pas de message </v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-layout>
            </v-card>
        </div>
        <oss-dialog
            v-model="showNotificationDialog"
            :title="
                $t('chat.notification.waitingResponse', unreadChatCount, {
                    count: unreadChatCount,
                })
            "
            width="800px"
        >
            <v-list>
                <v-list-item
                    :class="
                        !$vuetify.display.mobile ? 'mb-2 oss-list-item' : 'mb-2 px-2 oss-list-item'
                    "
                    @click="
                        showNotificationDialog = false;
                        filter = 'waitingResponse';
                        minus = false;
                    "
                >
                    <template v-if="!$vuetify.display.mobile">
                        <v-icon color="primary"> $fa-comments</v-icon>
                    </template>

                    <template v-slot:append>
                        <v-btn-next />
                    </template>
                    <v-list-item-title>{{
                        $t("chat.notification.showWaitingResponse", unreadChatCount)
                    }}</v-list-item-title></v-list-item
                >
                <v-list-item
                    :class="
                        !$vuetify.display.mobile ? 'mb-2 oss-list-item' : 'mb-2 px-2 oss-list-item'
                    "
                    @click.stop="showDocuments()"
                    v-if="chatWithDocuments.length"
                >
                    <template v-if="!$vuetify.display.mobile">
                        <v-icon color="primary">$fa-file-pdf</v-icon>
                    </template>

                    <template v-slot:append>
                        <v-btn-next />
                    </template>
                    <v-list-item-title>{{
                        $t(
                            "chat.notification.showWaitingResponseDocuments",
                            chatWithDocuments.length,
                            { count: chatWithDocuments.length },
                        )
                    }}</v-list-item-title></v-list-item
                >
                <v-list-item
                    :class="
                        !$vuetify.display.mobile ? 'mb-2 oss-list-item' : 'mb-2 px-2 oss-list-item'
                    "
                    @click.stop="showExpenseReports()"
                    v-if="chatWithExpenseReports.length"
                >
                    <template v-if="!$vuetify.display.mobile">
                        <v-icon color="primary">$fa-receipt</v-icon>
                    </template>

                    <template v-slot:append>
                        <v-btn-next />
                    </template>
                    <v-list-item-title>{{
                        $t(
                            "chat.notification.showWaitingResponseExpenseReports",
                            chatWithExpenseReports.length,
                            { count: chatWithExpenseReports.length },
                        )
                    }}</v-list-item-title></v-list-item
                >
                <v-list-item
                    :class="
                        !$vuetify.display.mobile ? 'mb-2 oss-list-item' : 'mb-2 px-2 oss-list-item'
                    "
                    @click.stop="showBankTransactions()"
                    v-if="chatWithBankTransactions.length"
                >
                    <template v-if="!$vuetify.display.mobile">
                        <v-icon color="primary">$fa-university</v-icon>
                    </template>

                    <template v-slot:append>
                        <v-btn-next />
                    </template>
                    <v-list-item-title>{{
                        $t(
                            "chat.notification.showWaitingResponseBankTransactions",
                            chatWithBankTransactions.length,
                            { count: chatWithBankTransactions.length },
                        )
                    }}</v-list-item-title></v-list-item
                >
            </v-list>
        </oss-dialog>

        <v-snackbar v-model="snackbar.show" :color="snackbar.color" :timeout="3000">
            {{ snackbar.message }}
        </v-snackbar>
    </div>
</template>

<script lang="ts">
import moment from "moment-timezone";
import { State2Way } from "@/decorators";
import { Apollo } from "@/decorators";
import { User } from "../../store/store";

import {
    openBankTransaction,
    defaultBankTransactionFilter,
} from "../../services/bankTransactionServices";
import { defaultDocumentFilter } from "../../services/documentServices";
import { showChatList } from "../../services/chatServices";

import CHATS from "../../graphql/chat/Chats.gql";
import BANK_TRANSACTION_CHATS from "../../graphql/chat/BankTransactionChats.gql";
import DOCUMENT_CHATS from "../../graphql/chat/DocumentChats.gql";
import EXPENSE_REPORT_CHATS from "../../graphql/chat/ExpenseReportChats.gql";
import MARK_CHAT_AS_PROCESSED from "../../graphql/chat/MarkChatAsProcessed.gql";
import CREATE_MESSAGE from "../../graphql/chat/CreateMessage.gql";

import { Chat } from "../../../../types";
import { NotificationBase } from "../NotificationBase";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";
import { Watch } from "vue-facing-decorator";
import { getUserDisplayName } from "@/services/userServices";

@Component
export class ChatList extends NotificationBase {
    @Prop({ default: "" }) objectFilter: string;
    @Prop({ default: "" }) position: string;

    minus = true;

    filter = "all";

    showNotificationDialog = false;
    showNotificationDone = false;

    menuOpen: string | null = null;
    hoveredItem: string | null = null;
    snackbar = {
        show: false,
        message: "",
        color: "primary",
    };

    @State2Way("updateBankTransactionFilter", "bankTransactionFilter")
    btFilter!: any;

    @State2Way(
        "updateBankTransactionReconciliationStatus",
        "bankTransactionFilter.reconciliationStatus",
    )
    btReconciliationStatus: string;

    @State2Way("updateDocumentFilter", "documentFilter")
    documentFilter!: any;

    @State2Way("updateDocumentStatus", "documentFilter.status")
    documentStatus!: string;

    get title() {
        return this.$t("chat.title." + this.filter);
    }

    get chatWithDocuments() {
        const chats = [];
        for (const chat of this.waitingChats) {
            if (chat.document) {
                chats.push(chat);
            }
        }
        return chats;
    }

    get chatWithExpenseReports() {
        const chats = [];
        for (const chat of this.waitingChats) {
            if (chat.expenseReport) {
                chats.push(chat);
            }
        }
        return chats;
    }

    get chatWithBankTransactions() {
        const chats = [];
        for (const chat of this.waitingChats) {
            if (chat.bankTransaction) {
                chats.push(chat);
            }
        }
        return chats;
    }

    get waitingChats() {
        const chats = [];
        for (const chat of this.chats) {
            if (!chat.lastMessage.sender || !chat.lastMessage.sender.company) {
                continue;
            }
            if (chat.document && chat.document.status !== "INFORMATION_REQUEST") {
                continue;
            }
            if (chat.bankTransaction && chat.bankTransaction.status !== "INFORMATION_REQUEST") {
                continue;
            }
            if (chat.expenseReport && chat.expenseReport.status !== "INFORMATION_REQUEST") {
                continue;
            }
            if (!chat.document && !chat.bankTransaction && !chat.expenseReport) {
                continue;
            }
            if (this.currentUser?.company?.id !== chat.lastMessage?.sender?.company?.id) {
                chats.push(chat);
            }
        }
        return chats;
    }

    getChatsWithMessageSent() {
        const chats = [];
        for (const chat of this.chats) {
            if (!chat.lastMessage.sender || !chat.lastMessage.sender.company) {
                continue;
            }
            if (chat.document && chat.document.status !== "INFORMATION_REQUEST") {
                continue;
            }
            if (chat.bankTransaction && chat.bankTransaction.status !== "INFORMATION_REQUEST") {
                continue;
            }
            if (chat.expenseReport && chat.expenseReport.status !== "INFORMATION_REQUEST") {
                continue;
            }
            if (this.currentUser?.company?.id === chat.lastMessage?.sender?.company?.id) {
                chats.push(chat);
            }
        }
        return chats;
    }

    getClosedChats() {
        const chats = [];
        for (const chat of this.chats) {
            if (chat.document && chat.document.status !== "INFORMATION_REQUEST") {
                chats.push(chat);
            }
            if (chat.bankTransaction && chat.bankTransaction.status !== "INFORMATION_REQUEST") {
                chats.push(chat);
            }
            if (chat.expenseReport && chat.expenseReport.status !== "INFORMATION_REQUEST") {
                chats.push(chat);
            }
        }
        return chats;
    }

    get unreadChatCount() {
        return this.waitingChats.length;
    }

    get filteredChats() {
        const filterActions: Record<string, () => any[]> = {
            all: () => this.chats,
            waitingResponse: () => this.waitingChats,
            messageSent: () => this.getChatsWithMessageSent(),
            messageClosed: () => this.getClosedChats(),
        };

        // Use the function corresponding to the selected filter, otherwise return `this.chats`.
        const chats = (filterActions[this.filter] || (() => this.chats))();

        // Sort by date last message created (oldest to most recent)
        return chats.sort(
            (a, b) =>
                new Date(a.lastMessage.createdAt).getTime() -
                new Date(b.lastMessage.createdAt).getTime(),
        );
    }

    get rightPosition() {
        return this.position || "10px";
    }

    get showDialog() {
        return !this.minus;
    }

    set showDialog(value) {
        this.minus = !value;
    }

    reduce() {
        this.minus = !this.minus;
    }

    toggleMenu(itemId: string) {
        this.menuOpen = this.menuOpen === itemId ? null : itemId;
    }

    /**
     * Mark a chat as processed and show a notification
     * @param chatId - ID du chat
     */
    async markChatAsProcessed(chatId: string) {
        if (!chatId) return;
        const companyId = this.selectedCompany?.id;
        this.menuOpen = null;

        try {
            await this.$apollo.mutate({
                mutation: MARK_CHAT_AS_PROCESSED,
                variables: { id: chatId, companyId: companyId },
            });

            this.showToast("La conversation a été marqué comme traité !");
        } catch (error) {
            console.error("Erreur lors du traitement de la conversation :", error);
            this.showToast("Une erreur est survenue lors du traitement la conversation", "error");
        }
    }

    /**
     * Relaunch chat and show a notification
     * @param chat - Chat to relaunch
     */
    async relaunchChat(chat: Chat) {
        if (!chat?.id || !chat.lastMessage?.text) return;

        const chatId = chat.id;
        const message = chat.lastMessage.text;
        const companyId = this.selectedCompany?.id;
        const userId = this.currentUser?.id;

        this.menuOpen = null;

        try {
            await this.$apollo.mutate({
                mutation: CREATE_MESSAGE,
                variables: {
                    chatId,
                    chatType: "OBJECT",
                    companyId,
                    userId,
                    message,
                    type: "",
                },
            });

            this.showToast("La conversation a été relancée avec succès !");
        } catch (error) {
            console.error("Erreur lors de la relance de la conversation :", error);
            this.showToast("Une erreur est survenue lors de la relance.", "error");
        }
    }

    /**
     * Displays a notification with v-snackbar
     * @param message - The message to display
     * @param color - The color of the snackbar (default: "primary")
     */
    showToast(message: string, color = "primary") {
        this.snackbar = { show: true, message, color };
    }

    getDate(date: string) {
        return moment(date).fromNow(true);
    }

    getItemHeight(itemId) {
        // Trouver l'élément v-list-item parent
        const listItem = document.querySelector(`[data-item-id="${itemId}"]`);
        if (listItem) {
            return listItem.clientHeight;
        }
        return 78; // Hauteur par défaut si l'élément n'est pas trouvé
    }

    get selectedCompany() {
        return this.$store.state.selected_company;
    }

    get selectedCompanyId() {
        return this.selectedCompany?.id;
    }

    get currentUser(): User {
        return this.$store.state.user;
    }

    get isInAccountingFirm() {
        return this.currentUser.isInAccountingFirm;
    }

    @Watch("unreadChatCount")
    onUnreadChatCountChanged() {
        if (this.showNotificationDone) return;
        if (showChatList(this.$router.currentRoute.value)) {
            this.showNotificationDone = true;
            if (this.unreadChatCount) {
                this.showNotificationDialog = true;
            }
        }
    }

    // updateScrollTop() {
    //     const htmlElement = document.getElementById("chatMessages");
    //     // Ne Fonctionne Pas
    //     // chatMessages.scrollTop = chatMessages.scrollHeight;
    //     if (htmlElement) {
    //         htmlElement.scrollTop = htmlElement.scrollHeight - htmlElement.clientHeight;
    //     }
    // }
    // @Watch("minus")
    // onMinusChanged(value, prevValue) {
    //     if (value === false && prevValue === true) {
    //         // chat
    //         if (this.$apollo.queries && this.$apollo.queries.chats) {
    //             this.$apollo.queries.chats.start();
    //         } else {
    //             this.$apollo.addSmartQuery("chats", {
    //                 query() {
    //                     return !this.objectFilter? CHATS :this.objectFilter === "BankTransaction" ? BANK_TRANSACTION_CHATS : this.objectFilter === "ExpenseReport" ? EXPENSE_REPORT_CHATS : DOCUMENT_CHATS
    //                 },
    //                 variables() {
    //                     return {
    //                         companyId: this.selectedCompany.id,
    //                     };
    //                 },
    //                 result: ({ data, loading, networkStatus }: any) => {
    //                     if (!loading) {
    //                         if (data) {
    //                             // console.log(data);
    //                             // this.chat = data.chat;
    //                             // setTimeout(() => { this.updateScrollTop() }, 0);
    //                         }
    //                     }
    //                 },
    //                 skip() {
    //                     return !this.selectedCompany.id;
    //                 }
    //             });
    //         }
    //     } else if (this.$apollo.queries && this.$apollo.queries.chats) {
    //         this.$apollo.queries.chats.stop();
    //     } else {
    //         debugger
    //     }
    // }

    get companyId() {
        return this.selectedCompanyId;
    }

    chatSubcription: any;

    onMessage(data) {
        if (data.action === "create") {
            if (data.payload.type !== "OBJECT") {
                return;
            }
            this.chats.push(data.payload);
        } else if (data.action === "update") {
            const index = this.chats.findIndex((aie) => aie.id === data.id);
            if (index !== -1) {
                this.chats.splice(index, 1, data.payload);
            }
        } else if (data.action === "delete") {
            const index = this.chats.findIndex((aie) => aie.id === data.id);
            if (index !== -1) {
                this.chats.splice(index, 1);
            }
        }
    }

    @Apollo({
        query() {
            return !this.objectFilter
                ? CHATS
                : this.objectFilter === "BankTransaction"
                  ? BANK_TRANSACTION_CHATS
                  : this.objectFilter === "ExpenseReport"
                    ? EXPENSE_REPORT_CHATS
                    : DOCUMENT_CHATS;
        },
        variables() {
            return {
                companyId: this.companyId,
            };
        },
        // debounce: 500,
        skip() {
            return !this.companyId;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data?.chats) {
                    this.chats = data.chats;
                    this.showNotificationDone = false;
                    this.onUnreadChatCountChanged();
                    this.addListener(["chat"]);
                } else {
                    this.chats = [];
                    this.removeListener();
                }
            }
        },
    })
    chats: Chat[] = [];

    beforeDestroy() {
        if (this.$apollo.queries && this.$apollo.queries.chats) {
            this.$apollo.queries.chats.stop();
        }
        this.removeListener();
    }

    // Watcher sur 'chats'
    @Watch("filteredChats", { deep: true })
    onFilteredChatsChanged() {
        this.$nextTick(() => {
            this.scrollToLatestChat();
        });
    }
    @Watch("showDialog")
    onShowDialogChanged(newVal) {
        if (newVal) {
            this.$nextTick(() => {
                this.scrollToLatestChat();
            });
        }
    }
    scrollToLatestChat() {
        this.$nextTick(() => {
            const chatItems = this.$el.querySelectorAll(".oss-list-item");

            if (chatItems.length > 0) {
                const lastItem = chatItems[chatItems.length - 1];
                lastItem.scrollIntoView({ block: "end" }); // 🔥 Aller directement en bas sans scroll visible
            }
        });
    }

    /*     openChat(chat) {
    openChat(chat) {
        if (!this.selectedCompanyId) {
            debugger;
            return;
        }
        if (chat) {
            if (chat.bankTransaction) {
                openBankTransaction(
                    this.$router,
                    this.currentUser,
                    this.selectedCompanyId,
                    chat.bankTransaction,
                );
            } else if (chat.document) {
                this.$router.push({
                    name: "document",
                    params: {
                        companyId: this.selectedCompanyId,
                        id: chat.document.id,
                    },
                });
            } else if (chat.expenseReport) {
                this.$router.push({
                    name: "expenseReport",
                    params: {
                        companyId: this.selectedCompanyId,
                        id: chat.expenseReport.id,
                    },
                });
            }
        }

        this.$emit("chatSelected", {
            chat: chat,
        });
        this.showDialog = false;
    }
 */

    openChat(chat: Chat) {
        if (chat) {
            this.$nextTick(() => {
                this.scrollToChat(chat); // S'assure que le scroll se fait après la mise à jour du DOM
            });
        }

        if (chat.bankTransaction) {
            openBankTransaction(
                this.$router,
                this.currentUser,
                this.selectedCompany.id,
                chat.bankTransaction,
            );
        } else if (chat.document) {
            this.$router.push({
                name: "document",
                params: {
                    companyId: this.selectedCompany.id,
                    id: chat.document.id,
                },
            });
        } else if (chat.expenseReport) {
            this.$router.push({
                name: "expenseReport",
                params: {
                    companyId: this.selectedCompany.id,
                    id: chat.expenseReport.id,
                },
            });
        }

        this.$emit("chatSelected", { chat: chat });
        this.showDialog = false;
    }

    scrollToChat(chat: Chat) {
        const chatItem = this.$el.querySelector(`#chat-${chat.id}`);
        if (chatItem) {
            chatItem.scrollIntoView({ behavior: "smooth", block: "start" });
        }
    }

    showDocuments() {
        this.showNotificationDialog = false;
        if (this.chatWithDocuments.length === 1) {
            this.openChat(this.chatWithDocuments[0]);
            return;
        }
        if (this.$router.currentRoute.value.name !== "documents") {
            this.$router.push({
                name: "documents",
                params: {
                    resetFilter: "true",
                    status: "INFORMATION_REQUEST",
                },
            });
        } else {
            this.documentFilter = JSON.parse(JSON.stringify(defaultDocumentFilter));
            this.documentStatus = "INFORMATION_REQUEST";
        }
    }

    showExpenseReports() {
        this.showNotificationDialog = false;
        if (this.chatWithExpenseReports.length === 1) {
            this.openChat(this.chatWithExpenseReports[0]);
            return;
        }
        this.$router.push({
            name: "expenseReports",
            params: {
                resetFilter: "true",
                status: "INFORMATION_REQUEST",
            },
        });
    }

    showBankTransactions() {
        this.showNotificationDialog = false;
        if (this.chatWithBankTransactions.length === 1) {
            this.openChat(this.chatWithBankTransactions[0]);
            return;
        }
        if (this.$router.currentRoute.value.name !== "bank") {
            this.$router.push({
                name: "bank",
                params: {
                    resetFilter: "true",
                    reconciliationStatus: "INFORMATION_REQUEST",
                },
            });
        } else {
            this.btFilter = JSON.parse(JSON.stringify(defaultBankTransactionFilter));
            this.btReconciliationStatus = "INFORMATION_REQUEST";
        }
    }

    getType(item) {
        if (item.document) return "Document";
        if (item.bankTransaction) return "Banque";
        if (item.expenseReport) return "Note de frais";
    }

    getTypeIcon(item) {
        if (item.document) return "$receipt"; // TODO change document Icon
        if (item.bankTransaction)
            return item.bankTransaction.account && item.bankTransaction.account.type === "CASH_BOX"
                ? "$fa-cash-register"
                : "$fa-university";
        if (item.expenseReport) return "$receipt";
        return "";
    }

    getUserBigram(sender) {
        if (sender) {
            let bigram = sender?.firstname?.[0] || "";
            bigram += sender.lastname?.[0];
            return bigram;
        }
        return "XXX XXX";
    }

    getUserDisplayName(user) {
        return getUserDisplayName(user);
    }

    get boutonStyle() {
        if (!this.$vuetify.display.mobile) {
            return "position: fixed; right: 20px; bottom: 1vh; z-index: 10";
        }
        return "position: fixed; right:" + this.rightPosition + "; bottom: 60px; z-index: 10;";
    }
}

export default toNative(ChatList);
</script>

<style lang="scss" scoped>
.menu-container {
    display: flex;
    align-items: center;
    position: absolute;
    right: 16px;
    top: 12px;
}

.menu-button {
    background-color: #fdb933;
    color: white;
    border-radius: 6px 0 0 6px !important;
    transition: transform 0.3s ease-in-out;
    transform: translate(16px, 30px);
    width: 20px;
    height: 30px;
    font-size: 6px;

    &.menu-open {
        transform: translate(-81px, 30px);
        font-size: 24px;
    }
}

.menu-actions {
    display: flex;
    flex-direction: column;
    justify-content: center;
    background: white;
    border-radius: 8px;
    padding: 0 6px;
    position: absolute;
    transform: translateX(36px);
    transition: transform 0.3s ease-in-out;
    border: 2px solid #fdb933;
    top: -12px;
    height: 78px;
    &--open {
        transform: translateX(-62px);
    }
}

.menu-item {
    display: flex;
    align-items: center;
    flex: 0 0 20px;
    font-size: 12px;
    color: #525252;
    padding: 3px 8px 3px 5px;
    height: 100%;
    white-space: nowrap;
    cursor: pointer;
    transition: background-color 0.2s;
    &:hover {
        background-color: #f5f5f5;
    }
}

.oss-list-item {
    &__icon {
        position: absolute;
        right: 0;
        top: 0;
        border-radius: 50%;
        background-color: #4fcc53;
        color: white;
        font-size: 15px;
    }
}
</style>
